import React from 'react';
import { SaveStatus } from '@/hooks/domains/portfolio/usePortfolioAutosave';
import { Check, Loader2, AlertCircle } from 'lucide-react';

interface SaveStatusIndicatorProps {
  status: SaveStatus;
  className?: string;
}

/**
 * Subtle save status indicator for autosave
 * Shows a small icon with text indicating save status
 */
export const SaveStatusIndicator: React.FC<SaveStatusIndicatorProps> = ({
  status,
  className = '',
}) => {
  return (
    <div className={`flex items-center gap-2 text-sm ${className}`}>
      {status === 'saving' && (
        <>
          <Loader2 className="h-4 w-4 animate-spin text-gray-500" />
          <span className="text-gray-500">Saving...</span>
        </>
      )}
      {status === 'saved' && (
        <>
          <Check className="h-4 w-4 text-green-600" />
          <span className="text-green-600">Saved</span>
        </>
      )}
      {status === 'error' && (
        <>
          <AlertCircle className="h-4 w-4 text-red-600" />
          <span className="text-red-600">Save failed</span>
        </>
      )}
      {status === 'idle' && null}
    </div>
  );
};
